import React from "react";
import { Link, useLocation } from "react-router-dom";
import MuiNavTooltip from "../../common/MuiButton/MuiNavTooltip";
import { RiHome4Line, RiStackLine, } from "react-icons/ri";
import { MdOutlineEmojiEvents, } from "react-icons/md";
import CustomModal from "../../common/CustomModalV2";

function Footer({ currSlide }) {
   const location = useLocation();
   return (
      <div className="footer-part">

         {/* <CustomModal /> */}

         <ul>
            <li>
               <Link to="/home" style={{ textDecorationLine: "none", pointerEvents: currSlide ? 'none' : null }}>
                  <div className="footer-link">
                     <div className="image">
                        <RiHome4Line className={`footer-icon ${(location.pathname.includes("/home") || location.pathname == "/") ? "active" : ""}`} />
                     </div>
                     <Link
                        to="/home"
                        className={`link ${(location.pathname.includes("/home") || location.pathname == "/") ? `active` : ""
                           }`}
                     >
                        <h6>Home</h6>
                     </Link>
                  </div>
               </Link>
            </li>
            <li>
               <MuiNavTooltip open={currSlide === 1 ? true : false} title="Go here to view all indi programs" placement='top'>
                  <Link to="programs" style={{ textDecorationLine: "none", pointerEvents: currSlide ? 'none' : null }}>
                     <div className="footer-link">
                        <div className="image">
                           <RiStackLine className={`footer-icon ${(location.pathname.includes("program") || location.pathname.includes("workout")) ? "active" : ""}`} />
                        </div>
                        <Link
                           to="/programs"
                           className={`link ${location.pathname.includes("program") ||
                              location.pathname.includes("workout")
                              ? "active"
                              : ""
                              }`}
                        >
                           <h6>Programs</h6>
                        </Link>
                     </div>
                  </Link>
               </MuiNavTooltip>
            </li>
            <li>
               <Link to="/challenges" style={{ textDecorationLine: "none", pointerEvents: currSlide ? 'none' : null }}>
                  <div className="footer-link">
                     <div className="image">
                        <MdOutlineEmojiEvents className={`footer-icon ${location.pathname.includes("/challenges") ? "active" : ""}`} />
                     </div>
                     <Link
                        to="/challenges"
                        className={`link ${location.pathname.includes("/challenges") ? "active" : ""
                           }`}
                     >
                        <h6>Challenges</h6>
                     </Link>
                  </div>
               </Link>
            </li>
         </ul>
      </div>
   );
}

export default Footer;
